import { List, Paper, Text, Title } from "@mantine/core";
import { EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import useAuthStore from "../../store/useAuthStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Experience = () => {
  const { profile } = useProfileStore();
  const experience = profile?.experiences || [];
  const { cvProcessing } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formatDate = (
    date?: { day?: number; month?: number; year?: number } | null
  ): string => {
    if (!date) return "";

    const { month, year } = date;

    if (year && month) {
      const formattedMonth = month.toString().padStart(2, "0");
      return `${formattedMonth}.${year}`;
    }

    if (year) {
      return `${year}`;
    }

    return "";
  };

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/experience")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("experience")}
      </Title>

      {experience.length > 0 ? (
        experience.map((job, index) => {
          const start = formatDate(job.start_date);
          const end = formatDate(job.end_date);
          const dateRange =
            start && end ? `${start} - ${end}` : start || end || "";

          return (
            <div key={index}>
              <Title
                size={24}
                mt={40}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: "100%",
                }}
              >
                {job.job_title}
              </Title>
              <Text
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: "100%",
                }}
                mt={8}
              >
                {job.company}
              </Text>
              <Text mt={8} c="#737373">
                {dateRange}
              </Text>
              <Text
                mt={8}
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  whiteSpace: "pre-line",
                }}
              >
                {job.responsibilities}
              </Text>
            </div>
          );
        })
      ) : (
        <Text mt={30} c="#737373">
          {cvProcessing !== "processing"
            ? t("no_experience")
            : t("no_experience_cv")}
        </Text>
      )}
    </Paper>
  );
};
